<ui-card [uiBordered]="false" [uiHeadBorderless]="true" [uiRounded]="true" [uiExtra]="extraHeaderContentTemplate" [uiTitle]="title">
  <ng-template #extraHeaderContentTemplate>
    <button [attr.aria-label]="'close' | localize" (click)="close()" ui-button>
      <i ui-icon uiType="close"></i>
    </button>
  </ng-template>

  <div class="boxes-container">
    <div class="box" *ngFor="let box of boxes">
      <i [uiType]="box.icon" ui-icon></i>
      <div class="type">{{ box.type }}</div>
      <div class="title">{{ box.title }}</div>
      <a class="ui-link" [href]="box.link" ui-external-link target="_blank">{{ "learn_more" | localize }}</a>
    </div>
  </div>
</ui-card>
